import { DataPlatformVisitRow } from './data-platform.model';

/** The contact's organization, else an anonymous visitor's company network. */
export function visitOrganization(
  visit: Pick<DataPlatformVisitRow, 'organization' | 'netName' | 'isIsp' | 'identifier' | 'email' | 'name'>,
): string | null {
  const isAnonymous = !visit.identifier && !visit.email && !visit.name?.trim();
  return visit.organization || (isAnonymous && !visit.isIsp && visit.netName) || null;
}
